import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private readonly SCRIPT_ID = 'google-maps-sdk';

  /**
   * Injects the Google Maps script tag into the document head if it doesn't exist.
   * Relying on native browser loading and google.maps.importLibrary for synchronization.
   */
  public injectScript(): void {
    if (document.getElementById(this.SCRIPT_ID) || (window as any).google?.maps) {
      return;
    }

    const script = document.createElement('script');
    script.id = this.SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.apiKeyGoogleMaps}&loading=async&libraries=places`;
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);
  }
}
